import { useQuery } from '@tanstack/react-query';
import { PRIORITY_DATES_KEY } from '../../utils/constants/queryKeys';
import { getPriorityDates } from '../services/fn-api/Immigration';

export const useGetPriorityDates = (beneId: number | undefined) => {
  return useQuery({
    queryKey: [PRIORITY_DATES_KEY, beneId],
    queryFn: () => getPriorityDates(beneId),
    enabled: !!beneId,
  });
};
